import { z } from 'zod';
import { defineEndpoint } from '../define';

/**
 * Verify stored UDIDs against the App Store Connect device list (ground
 * truth). Rows found on the portal are marked verified (and registered, if
 * they weren't yet); rows missing from the portal are reset to Pending so the
 * next register dispatch picks them up again. Requires
 * `releases:udids:manage`; 503 when App Store Connect is not configured.
 */
export const verifyAppleUdids = defineEndpoint({
  method: 'POST',
  path: '/v1/apple-udids/verify',
  params: z.object({}),
  query: z.object({}),
  body: z.object({}).strict(),
  response: z.object({
    data: z.object({
      /** Rows confirmed present on the Apple portal. */
      verified: z.number(),
      /** Rows not on the portal — reset to Pending. */
      missing: z.array(
        z.object({
          udid: z.string(),
          label: z.string(),
          user: z.object({ id: z.string().uuid(), displayName: z.string(), email: z.string() }),
        }),
      ),
      /** Portal devices not tracked here (informational count). */
      portalOnly: z.number(),
    }),
  }),
});
